import Header from './Header';

import styles from './ApiKeys.module.scss';
import ApiKeysCards from './ApiKeysCards';

const ApiKeys = () => {
  return (
    <div className={styles['api-keys']}>
      <Header />
      <ApiKeysCards />
    </div>
  );
};

export default ApiKeys;
